import * as yup from 'yup'

export const documentSchema = yup.object().shape({
    name_file: yup.string().required('Chưa nhập tên file'),
    descriptions: yup.string().required('Chưa Nhập mô tả'),
    document_type: yup.string().required('Chưa chọn loại tài liệu'),
    document_level: yup.string().required('Chưa chọn mức độ tài liệu'),
    departments: yup
        .array()
        .of(yup.number().required())
        .when('sharing_enable', {
            is: true,
            then: (schema) => schema,
            otherwise: (schema) => schema.notRequired(),
        }),

    employees: yup
        .array()
        .of(yup.number().required())
        .when('sharing_enable', {
            is: true,
            then: (schema) => schema,
            otherwise: (schema) => schema.notRequired(),
        }),
})
